<template>
  <div id="rookie">
    <img :src="imgUrl" alt="" :width="width" style="display:block"/>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "RookieStrategy",
  data() {
    return {
      imgUrl:
        "https://image.fangpinyouxuan.com/App%E9%85%8D%E5%9B%BE/RookieStrategy.png",
      width: 0,
    };
  },
  mounted() {
    this.setImgWidth();
  },
  methods: {
    setImgWidth() {
      this.width = $(document).width();
    },
  },
};
</script>

<style lang="sass" scoped></style>
